import React from 'react';
import { connect } from 'react-redux';

import {
  incidentDetailsFetchChannelEvidencesTypes,
  incidentDetailsFetchDetectionLinkData,
  incidentDetailsFetchDetectionLinkEvidences,
  incidentDetailsFetchDetectionLinkMetaData,
  incidentDetailsSearchDetectionLinkAccount,
  incidentDetailsSetDetectionLinkCommonLinkData,
  incidentDetailsSetDetectionLinkEvidence,
  incidentDetailsSetDetectionLinkImages,
  incidentDetailsSetDetectionLinkModifiedAccount,
  incidentDetailsSetDetectionLinkMultimediaFile,
  incidentDetailsSetDetectionLinkOfferListing,
  incidentDetailsSetDetectionLinkOverallMultimedia,
  incidentDetailsSetDetectionLinkPriceList,
  incidentDetailsSetDetectionLinkProductListing,
  incidentDetailsSetDetectionLinkSeller,
  incidentDetailsSetDetectionLinkSocialMedia,
  incidentDetailsSetDetectionLinkValidationAccount,
  incidentDetailsSetDetectionLinkValidationCommonLinkData,
  incidentDetailsSetDetectionLinkValidationEvidence,
  incidentDetailsSetDetectionLinkValidationLinkImageList,
  incidentDetailsSetDetectionLinkValidationLinkPriceList,
  incidentDetailsSetDetectionLinkValidationMultimediaFile,
  incidentDetailsSetDetectionLinkValidationOfferListing,
  incidentDetailsSetDetectionLinkValidationOverallMultimedia,
  incidentDetailsSetDetectionLinkValidationProductListing,
  incidentDetailsSetDetectionLinkValidationSeller,
  incidentDetailsSetDetectionLinkValidationSocialMedia,
} from '../../../actions/incidentDetailsActions';
import {
  getIncidentDetailsDestinationLinks,
  getIncidentDetailsDetectionAdLinks,
  getIncidentDetailsDetectionLinkAccountModified,
  getIncidentDetailsDetectionLinkData,
  getIncidentDetailsDetectionLinkEnforcementStatus,
  getIncidentDetailsDetectionLinkEvidenceIsMandatory,
  getIncidentDetailsDetectionLinkEvidences,
  getIncidentDetailsDetectionLinkEvidencesIsLoading,
  getIncidentDetailsDetectionLinkMetaData,
  getIncidentDetailsDetectionLinkMonitorData,
  getIncidentDetailsDetectionLinkSearchAccountIsLoading,
  getIncidentDetailsDetectionLinkSearchAccountStatus,
  getIncidentDetailsDetectionLinkSeller,
  getIncidentDetailsIncidentData,
  getIncidentDetailsIsAdDetectionLink,
} from '../../../reducers/reporting/incidentDetails';
import IncidentDetailsLinkDataContent from './IncidentDetailsLinkDataContent';

const IncidentDetailsDetectionLinkContent = ({
  accountData,
  adLinks,
  destinationLinks,
  enforcementStatus,
  evidenceData,
  evidenceIsMandatory,
  evidencesIsLoading,
  incidentData,
  incidentDetailsSearchDetectionLinkAccount,
  incidentDetailsSetDetectionLinkCommonLinkData,
  incidentDetailsSetDetectionLinkEvidence,
  incidentDetailsSetDetectionLinkImages,
  incidentDetailsSetDetectionLinkModifiedAccount,
  incidentDetailsSetDetectionLinkMultimediaFile,
  incidentDetailsSetDetectionLinkOfferListing,
  incidentDetailsSetDetectionLinkOverallMultimedia,
  incidentDetailsSetDetectionLinkPriceList,
  incidentDetailsSetDetectionLinkProductListing,
  incidentDetailsSetDetectionLinkSeller,
  incidentDetailsSetDetectionLinkSocialMedia,
  incidentDetailsSetDetectionLinkValidationAccount,
  incidentDetailsSetDetectionLinkValidationCommonLinkData,
  incidentDetailsSetDetectionLinkValidationEvidence,
  incidentDetailsSetDetectionLinkValidationLinkImageList,
  incidentDetailsSetDetectionLinkValidationLinkPriceList,
  incidentDetailsSetDetectionLinkValidationMultimediaFile,
  incidentDetailsSetDetectionLinkValidationOfferListing,
  incidentDetailsSetDetectionLinkValidationOverallMultimedia,
  incidentDetailsSetDetectionLinkValidationProductListing,
  incidentDetailsSetDetectionLinkValidationSeller,
  incidentDetailsSetDetectionLinkValidationSocialMedia,
  isAdLink,
  isSearchLoading,
  linkData,
  linkMetadata,
  monitorData,
  searchStatus,
  sellerData,
}) => {
  const handleCommonLinkDataChange = commonLinkData =>
    incidentDetailsSetDetectionLinkCommonLinkData({ commonLinkData });

  const handleCommonLinkDataValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationCommonLinkData({ isValid });

  const handleLinkImageListLinkDataChange = images =>
    incidentDetailsSetDetectionLinkImages({ images });

  const handleLinkImageListLinkDataValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationLinkImageList({ isValid });

  const handleLinkPriceListChange = priceList =>
    incidentDetailsSetDetectionLinkPriceList({ priceList });

  const handleLinkPriceListValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationLinkPriceList({ isValid });

  const handleMultimediaFileChange = multiMediaFile =>
    incidentDetailsSetDetectionLinkMultimediaFile({ multiMediaFile });

  const handleMultimediaFileValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationMultimediaFile({ isValid });

  const handleOfferListingChange = offerListing =>
    incidentDetailsSetDetectionLinkOfferListing({ offerListing });

  const handleOfferListingValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationOfferListing({ isValid });

  const handleOverallMultimediaLinkDataChange = overallMultimedia =>
    incidentDetailsSetDetectionLinkOverallMultimedia({ overallMultimedia });

  const handleOverallMultimediaLinkDataValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationOverallMultimedia({ isValid });

  const handleProductListingChange = productListing =>
    incidentDetailsSetDetectionLinkProductListing({ productListing });

  const handleProductListingValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationProductListing({ isValid });

  const handleSocialMediaLinkDataChange = socialMedia =>
    incidentDetailsSetDetectionLinkSocialMedia({ socialMedia });

  const handleSocialMediaLinkDataValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationSocialMedia({ isValid });

  const handleEvidenceChange = evidence =>
    incidentDetailsSetDetectionLinkEvidence({ evidence });

  const handleEvidenceValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationEvidence({ isValid });

  const handleSellerLinkDataChange = seller =>
    incidentDetailsSetDetectionLinkSeller({ seller });

  const handleSellerLinkDataValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationSeller({ isValid });

  const handleAccountLinkDataChange = account =>
    incidentDetailsSetDetectionLinkModifiedAccount({ account });

  const handleAccountLinkDataValidate = isValid =>
    incidentDetailsSetDetectionLinkValidationAccount({ isValid });

  const handleDetectionLinkAccountSearch = account =>
    incidentDetailsSearchDetectionLinkAccount({ account });

  return (
    <IncidentDetailsLinkDataContent
      isAdDetectionLink={isAdLink}
      adLinks={adLinks}
      destinationLinks={destinationLinks}
      accountData={accountData}
      accountLinkDataChange={handleAccountLinkDataChange}
      accountLinkDataValidate={handleAccountLinkDataValidate}
      commonLinkDataChange={handleCommonLinkDataChange}
      commonLinkDataValidate={handleCommonLinkDataValidate}
      enforcementStatus={enforcementStatus}
      evidenceChange={handleEvidenceChange}
      evidenceData={evidenceData}
      evidenceIsMandatory={evidenceIsMandatory}
      evidenceValidate={handleEvidenceValidate}
      evidencesIsLoading={evidencesIsLoading}
      linkData={linkData}
      linkId={incidentData.detectionLink?.detectionLinkId}
      linkImageListLinkDataChange={handleLinkImageListLinkDataChange}
      linkImageListLinkDataValidate={handleLinkImageListLinkDataValidate}
      linkInfo={incidentData.detectionLink}
      linkMetadata={linkMetadata}
      linkPriceListChange={handleLinkPriceListChange}
      linkPriceListValidate={handleLinkPriceListValidate}
      monitorData={monitorData}
      multimediaFileLinkDataChange={handleMultimediaFileChange}
      multimediaFileLinkDataValidate={handleMultimediaFileValidate}
      offerListingChange={handleOfferListingChange}
      offerListingValidate={handleOfferListingValidate}
      overallMultimediaChange={handleOverallMultimediaLinkDataChange}
      overallMultimediaValidate={handleOverallMultimediaLinkDataValidate}
      priority={incidentData.detectionLink?.priority}
      productListingChange={handleProductListingChange}
      productListingValidate={handleProductListingValidate}
      sellerData={sellerData}
      sellerLinkDataChange={handleSellerLinkDataChange}
      sellerLinkDataValidate={handleSellerLinkDataValidate}
      socialMediaLinkDataChange={handleSocialMediaLinkDataChange}
      socialMediaLinkDataValidate={handleSocialMediaLinkDataValidate}
      isSearchLoading={isSearchLoading}
      onSearch={handleDetectionLinkAccountSearch}
      searchStatus={searchStatus}
    />
  );
};

const mapStateToProps = state => ({
  accountData: getIncidentDetailsDetectionLinkAccountModified(state),
  adLinks: getIncidentDetailsDetectionAdLinks(state),
  destinationLinks: getIncidentDetailsDestinationLinks(state),
  enforcementStatus: getIncidentDetailsDetectionLinkEnforcementStatus(state),
  evidenceData: getIncidentDetailsDetectionLinkEvidences(state),
  evidenceIsMandatory: getIncidentDetailsDetectionLinkEvidenceIsMandatory(
    state
  ),
  evidencesIsLoading: getIncidentDetailsDetectionLinkEvidencesIsLoading(state),
  incidentData: getIncidentDetailsIncidentData(state),
  isAdLink: getIncidentDetailsIsAdDetectionLink(state),
  isSearchLoading: getIncidentDetailsDetectionLinkSearchAccountIsLoading(state),
  linkData: getIncidentDetailsDetectionLinkData(state),
  linkMetadata: getIncidentDetailsDetectionLinkMetaData(state),
  monitorData: getIncidentDetailsDetectionLinkMonitorData(state),
  searchStatus: getIncidentDetailsDetectionLinkSearchAccountStatus(state),
  sellerData: getIncidentDetailsDetectionLinkSeller(state),
});

export default connect(mapStateToProps, {
  incidentDetailsFetchChannelEvidencesTypes,
  incidentDetailsFetchDetectionLinkData,
  incidentDetailsFetchDetectionLinkEvidences,
  incidentDetailsFetchDetectionLinkMetaData,
  incidentDetailsSearchDetectionLinkAccount,
  incidentDetailsSetDetectionLinkModifiedAccount,
  incidentDetailsSetDetectionLinkCommonLinkData,
  incidentDetailsSetDetectionLinkEvidence,
  incidentDetailsSetDetectionLinkImages,
  incidentDetailsSetDetectionLinkMultimediaFile,
  incidentDetailsSetDetectionLinkOfferListing,
  incidentDetailsSetDetectionLinkOverallMultimedia,
  incidentDetailsSetDetectionLinkPriceList,
  incidentDetailsSetDetectionLinkProductListing,
  incidentDetailsSetDetectionLinkSeller,
  incidentDetailsSetDetectionLinkSocialMedia,
  incidentDetailsSetDetectionLinkValidationAccount,
  incidentDetailsSetDetectionLinkValidationCommonLinkData,
  incidentDetailsSetDetectionLinkValidationEvidence,
  incidentDetailsSetDetectionLinkValidationLinkImageList,
  incidentDetailsSetDetectionLinkValidationLinkPriceList,
  incidentDetailsSetDetectionLinkValidationMultimediaFile,
  incidentDetailsSetDetectionLinkValidationOfferListing,
  incidentDetailsSetDetectionLinkValidationOverallMultimedia,
  incidentDetailsSetDetectionLinkValidationProductListing,
  incidentDetailsSetDetectionLinkValidationSeller,
  incidentDetailsSetDetectionLinkValidationSocialMedia,
})(IncidentDetailsDetectionLinkContent);
